/**
 * @generated SignedSource<<62eef4fb4630b1ed77b600ede93b1b6d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutMobileSummaryPane_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutAvalaraTaxExempt_viewer" | "CheckoutDutiesMessage_viewer" | "CheckoutSidebarPromotion_viewer">;
  readonly " $fragmentType": "CheckoutMobileSummaryPane_viewer";
};
export type CheckoutMobileSummaryPane_viewer$key = {
  readonly " $data"?: CheckoutMobileSummaryPane_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutMobileSummaryPane_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutMobileSummaryPane_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDutiesMessage_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutAvalaraTaxExempt_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "7f42c82d1023d42b50500d8415e0549d";

export default node;
